module.exports = __webpack_public_path__ + "img/permisson-comparison4.7e9db324.jpg";